import App from '@/App.vue'
import { registerPlugins } from '@core/utils/plugins'
import { jsPDF } from "jspdf"
import { createApp } from 'vue'

// Styles
import '@core/scss/template/index.scss'
import '@styles/styles.scss'

// Create vue app
const app = createApp(App)

app.config.errorHandler = (err, instance, info) => {
  console.error('💥 전역 Vue 에러 발생!', err)
  console.log('🔍 에러 발생 컴포넌트:', instance)
  console.log('ℹ️ 추가 정보:', info)
  
  // 에러 로그 서버로 전송하거나 사용자에게 알림 가능
  // sendErrorToSentry(err)
  // showToast('앗! 알 수 없는 문제가 발생했어요.')
}
  
app.use(jsPDF)

// Register plugins
registerPlugins(app)

// Mount vue app
app.mount('#app')
